// One PBJ project as a card (Dashboard PBJ and the Project page, reference
// projectGrid): the current stage and TA, the name, unit kerja and jenis,
// the route with its method or type, the progress % with a bar, done/total
// activities, and Kelola. The whole card opens the project. A project sent
// to the viewer (access "member", Kirim dokumen tahap 0) carries Dibagikan.
import type { PbjProject } from "../api";
import { JENIS_LABEL } from "../project/stages";
import { projectPath } from "../shell/Projects";
import { Badge } from "../ui/components";
import { Glyph } from "../ui/icons";
import { PBJ_STAGE_LABEL, progressPct, routeText } from "./labels";

export function PbjProjectCard({ project: p }: { project: PbjProject }) {
  const pct = progressPct(p.done, p.total);
  const meta = [p.instansi || "Unit kerja belum diisi", p.jenisPengadaan ? JENIS_LABEL[p.jenisPengadaan] : null].filter(Boolean).join(", ");
  return (
    <a className="pbj-card" href={projectPath(p.id)}>
      <span className="pbj-card-top">
        <Glyph name="building" size={18} />
        <span className="pbj-card-stage">Tahap {PBJ_STAGE_LABEL[p.stage]}</span>
        {p.tahunAnggaran ? <span className="pbj-card-year num">TA {p.tahunAnggaran}</span> : null}
      </span>
      {p.access === "member" ? (
        <span className="pbj-card-shared">
          <Badge>Dibagikan</Badge>
        </span>
      ) : null}
      <span className="pbj-card-title">{p.name}</span>
      <span className="pbj-card-meta">{meta}</span>
      <span className="pbj-card-meta">{routeText(p)}</span>
      <span className="pbj-card-progress">
        <span className="pbj-card-row">
          <span>Progres siklus PBJ</span>
          <strong className="num">{pct}%</strong>
        </span>
        <span className="pbj-bar" aria-hidden="true">
          <span className="pbj-bar-fill" style={{ width: `${pct}%` }} />
        </span>
        <span className="pbj-card-row">
          <span className="num">
            {p.done}/{p.total} aktivitas
          </span>
          <span className="pbj-card-open">
            Kelola <Glyph name="chevronRight" size={16} />
          </span>
        </span>
      </span>
    </a>
  );
}
